// extracted by mini-css-extract-plugin
module.exports = {"results_section":"housing-results_results_section__5hoXO","results_toggle":"housing-results_results_toggle__3Bt4H","toggle-contents":"housing-results_toggle-contents__3uCBt"};